// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Menu from '../_raw/ui/icon_menu.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Menu);
